import {
    switchMap,
} from 'rxjs/operators';

import createManifestRotationStream from './createManifestRotationStream';

/**
 * @param {Observable<[Playback, Config, ResumePoints, Asset]>} playerLoad$
 * @param {playback-web-player.PlayerFacade} player
 * @returns {Observable}
 */

const createLoadManifestStream = (
    playerLoad$,
    player,
    handleError,
) =>
    playerLoad$
        .pipe(
            switchMap(loadData =>
                createManifestRotationStream(
                    player,
                    handleError,
                    loadData,
                )),
        );

export default createLoadManifestStream;
